module.exports = __webpack_public_path__ + "static/img/ledou.0748bf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/banner/ledou.jpg
// module id = rf7p
// module chunks = 0